<template>
  <div class="home-container">
    <my-head></my-head>
    <div class="banner-container">
      <div class="banner-box"></div>
    </div>
    <div class="serve-container">
      <div class="serve-main">
        <div class="caption">
          <span>我们的服务</span>
        </div>
        <div class="serve-content">
          <div class="serve-item supplier">
            <div class="serve-cover">
              <img src="../assets/images/supplier-serve.png" />
            </div>
            <div class="serve-name">
              <span>电商直供</span>
            </div>
            <div class="serve-text">
              <span>连接优质电商,实现物料查询,下单,支付和物流自动化流程解决方案。</span>
            </div>
          </div>
          <div class="serve-item api">
            <div class="serve-cover">
              <img src="../assets/images/api-serve.png" />
            </div>
            <div class="serve-name">
              <span>自动供应链</span>
            </div>
            <div class="serve-text">
              <span>通过API接口为您提供物料查询,订单创建等自动化服务,无需再通过商城查询物料,下单。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partner-container">
      <div class="partner-main">
        <div class="caption">
          <span>合作伙伴</span>
        </div>
        <ul class="partner-list">
          <li class="partner-item margin-right-30">
            <div class="partner-cove">
              <img src="../assets/images/partner-znl.png" />
            </div>
            <div class="partner-name">
              <span>正能量</span>
            </div>
          </li>
          <li class="partner-item margin-right-30">
            <div class="partner-cove">
              <img src="../assets/images/partner-qnw.png" />
            </div>
            <div class="partner-name">
              <span>全能王</span>
            </div>
          </li>
          <li class="partner-item margin-right-30">
            <div class="partner-cove">
              <img src="../assets/images/partner-sup.png" />
            </div>
            <div class="partner-name">
              <span>美隆电子</span>
            </div>
          </li>
          <li class="partner-item">
            <div class="partner-cove">
              <img src="../assets/images/partner-jp.png" />
            </div>
            <div class="partner-name">
              <span>捷配</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import MyHead from "@/components/MyHead.vue";
import MyFooter from "@/components/MyFooter.vue";
export default {
  name: "Home",
  components: {
    MyHead,
    MyFooter
  }
};
</script>

<style lang="less" scoped>
.banner-container {
  width: 100%;
  min-width: 1200px;
  height: 400px;
  background-color: #052726;
  .banner-box {
    margin: 0 auto;
    width: 1200px;
    height: 400px;
    background-image: url("../assets/images/banner.png");
  }
}
.serve-container {
  height: 400px;
  width: 100%;
  min-width: 1200px;
  background-color: #fff;
  .serve-main {
    overflow: hidden;
    margin: 0 auto;
    height: 400px;
    width: 1200px;
    > .caption {
      margin: 50px auto 0;
      height: 40px;
      font-size: 20px;
      line-height: 40px;
      color: #333;
      text-align: center;
    }
    .serve-content {
      position: relative;
      z-index: 10;
      height: 310px;
      .serve-item {
        width: 210px;
        &.supplier {
          position: absolute;
          z-index: 10;
          top: 0;
          left: 283px;
        }
        &.api {
          position: absolute;
          z-index: 10;
          top: 0;
          left: 704px;
        }
        > .serve-cover {
          margin: 0 auto;
          width: 130px;
          height: 154px;
          img {
            display: block;
          }
        }
        > .serve-name {
          height: 36px;
          font-size: 16px;
          line-height: 36px;
          color: #333;
          text-align: center;
        }
        > .serve-text {
          font-size: 14px;
          line-height: 1.5;
          color: #999;
          text-align: justify;
        }
      }
    }
  }
}
.partner-container {
  width: 100%;
  min-width: 1200px;
  height: 370px;
  .partner-main {
    overflow: hidden;
    margin: 0 auto;
    width: 1200px;
    height: 370px;
    background-image: url("../assets/images/partner-bg-left.png"),
      url("../assets/images/partner-bg-right.png");
    background-repeat: no-repeat, no-repeat;
    background-position: left bottom, right top;
    .caption {
      height: 140px;
      font-size: 20px;
      line-height: 160px;
      color: #333;
      text-align: center;
    }
    .partner-list {
      width: 1200px;
      height: 130px;
      white-space: nowrap;
      text-align: center;
      .partner-item {
        *display: inline;
        display: inline-block;
        zoom: 1;
        width: 257px;
        height: 150px;
        &.margin-right-30 {
          margin-right: 30px;
        }
        .partner-cove {
          overflow: hidden;
          width: 257px;
          height: 97px;
          background-color: #fff;
          -webkit-box-shadow: 0px 0px 5px 0px rgba(220, 220, 220, 1);
          box-shadow: 0px 0px 5px 0px rgba(220, 220, 220, 1);
          img {
            margin: 21px auto;
            width: 155px;
            display: block;
          }
        }
        .partner-name {
          height: 53px;
          font-size: 16px;
          line-height: 53px;
          text-align: center;
          color: #666;
        }
      }
    }
  }
}
</style>
